export const LOGIN_STUDENT = "[STUDENT] LOGIN_STUDENT";
export const LOGOUT_STUDENT = "[STUDENT] LOGOUT STUDENT";
export const SAVE_LOCAL_STUDENT = "[STUDENT] SAVE_LOCAL_STUDENT";
export const CLEAN_STUDENT_STATE = "[STUDENT] CLEAN_STUDENT_STATE";
